import React, { useState, useContext } from 'react';
import { QRCodeCanvas } from "qrcode.react";
import { ReactComponent as COPY } from '../../../../assets/IconsColurs/IconsGeneral/copy.svg';
import { copyToClipboard } from '../../../../utils/Utils';
import CopyNotification from '../../../banners/CopyNotification'
import { AuthContext } from '../../../../context/AuthContext';


const SingleQr = ({
    ID_user = 'nameUser@gmail.com',
    qrValue = "nameUser@gmail.com/12345678",
    centerImage
}) => {

    const [show, setShow] = useState(false)

    const Copy = () => {
        copyToClipboard(ID_user, setShow);
    };




    return (
        <>
            <CopyNotification show={show} />
            <p className='w-full flex mb-4 text-base font-normal text-[#B7B7B9] tracking-[-0.14px] leading-5'>
                Comparte tu código QR o ID para recibir el pago.
            </p>
            <div className='w-full h-[30vh] flex flex-col items-center justify-center my-7'>
                <div className='relative w-[200px] h-[200px] flex justify-center items-center'>
                    {/* Esquinas en forma de L */}
                    <div className="absolute top-0 left-0 w-6 h-6 border-t-4 border-l-4  border-white"></div>
                    <div className="absolute top-0 right-0 w-6 h-6 border-t-4 border-r-4   border-white"></div>
                    <div className="absolute bottom-0 left-0 w-6 h-6 border-b-4 border-l-4  border-white"></div>
                    <div className="absolute bottom-0 right-0 w-6 h-6 border-b-4 border-r-4  border-white"></div>

                    {/* QR Code */}
                    <div style={{ position: "relative", display: "inline-block" }}>
                        <QRCodeCanvas
                            value={qrValue}
                            size={180} // Tamaño del QR
                            bgColor="transparent" // Color de fondo
                            fgColor="#ffffff" // Color del QR
                            level="H" // Nivel de corrección de errores
                        />
                        <img
                            src={centerImage}
                            alt="Center Logo"
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "70px", // Tamaño de la imagen
                                height: "70px",
                                borderRadius: "50%",
                                background: "transparent",
                                padding: "5px",
                            }}
                        />
                    </div>
                </div>

                <div
                    className='w-auto h-auto flex flex-row gap-2 items-center justify-center cursor-pointer m-3'
                    onClick={Copy} // Convierte ID_user a string si es numérico
                >
                    <p className='flex text-base font-normal text-[#B7B7B9] tracking-[-0.14px] leading-5'>
                        ID de usuario:
                    </p>
                    <p className='flex text-base font-normal text-[#ffffff] tracking-[-0.14px] leading-5'>
                        {ID_user}
                    </p>
                    <COPY />
                </div>
            </div>
        </>
    );
};

export default SingleQr;
